<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			(setDialogHide) => {
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">CHI TIẾT VẬN ĐƠN </h4>
		</div>
		<div ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<vs-col vs-lg="5" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
				<div class="w-full menu-content-com ml-2">
					<div >
						<vs-row>
							<vs-col vs-lg="5" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full text-right">
									<label style="color: #999; font-size: 12px; font-weight: 500;">Mã vận đơn: <label style="color: #000;">{{ activeVanDon.code }}</label> </label>
								</div>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-lg="12" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full text-left">
									<label style="color: #000; font-size: 14px; font-weight: 600;">{{ activeVanDon.matching ? activeVanDon.matching.supplier_name : '-' }}</label>
								</div>
							</vs-col>
						</vs-row>
						<vs-row :set="statusDirective = $helper.getStatusAndColorNhatKy(activeVanDon)">
							<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full text-left">
									<label style="color: #999; font-size: 12px; font-weight: 500; display: block;">Mặt hàng</label>
									<label style="color: #000; font-size: 16px; font-weight: 500;">{{ activeVanDon.matching ? (activeVanDon.matching.product ? activeVanDon.matching.product.name : '-') : '-' }}</label>
								</div>
							</vs-col>
							<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full text-left">
									<label style="color: #999; font-size: 12px; font-weight: 500; display: block;">Đánh giá vận đơn</label>
									<div class="flex">
										<i :style="{width: '20px', fontSize: '1rem', cursor: 'pointer', color: checkReview(activeVanDon.supplier_rating, 1) ? '#F2994A' : '#828282'}" class="material-icons">star_rate</i>
										<i :style="{width: '20px', fontSize: '1rem', cursor: 'pointer', color: checkReview(activeVanDon.supplier_rating, 2) ? '#F2994A' : '#828282'}" class="material-icons">star_rate</i>
										<i :style="{width: '20px', fontSize: '1rem', cursor: 'pointer', color: checkReview(activeVanDon.supplier_rating, 3) ? '#F2994A' : '#828282'}" class="material-icons">star_rate</i>
										<i :style="{width: '20px', fontSize: '1rem', cursor: 'pointer', color: checkReview(activeVanDon.supplier_rating, 4) ? '#F2994A' : '#828282'}" class="material-icons">star_rate</i>
										<i :style="{width: '20px', fontSize: '1rem', cursor: 'pointer', color: checkReview(activeVanDon.supplier_rating, 5) ? '#F2994A' : '#828282'}" class="material-icons">star_rate</i>
									</div>
								</div>
							</vs-col>
							<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full text-left">
									<label style="color: #999; font-size: 12px; font-weight: 500; display: block;">Trạng thái</label>
									<label :style="{color: statusDirective.color, 'font-size': '16px', 'font-weight': 500}">{{ statusDirective.name }}</label>
								</div>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full text-left">
									<label style="color: #999; font-size: 12px; font-weight: 500; display: block;">Người đánh giá</label>
									<label style="color: #000; font-size: 16px; font-weight: 500;">{{ activeVanDon.voter ? activeVanDon.voter.name : '-' }}</label>
								</div>
							</vs-col>
							<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5" v-if="activeVanDon.humidity">
								<div class="w-full text-left">
									<label style="color: #999; font-size: 12px; font-weight: 500; display: block;">Độ ẩm</label>
									<label style="color: #000; font-size: 16px; font-weight: 500;">{{ activeVanDon.humidity }}</label>
								</div>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-lg="12" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full text-left">
									<label style="color: #999; font-size: 12px; font-weight: 500; display: block;">Nội dung đánh giá</label>
									<label style="color: #000; font-size: 16px; font-weight: 500;">{{ activeVanDon.kcs_note ? activeVanDon.kcs_note : 'Chưa có' }}</label>
								</div>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-lg="12" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
								<div class="w-full text-left">
									<label style="color: #999; font-size: 12px; font-weight: 500; display: block;">Hình ảnh KCS cung cấp </label>
								</div>
							</vs-col>
						</vs-row>
						<div class="flex flex-grow justify-start flex-wrap">
							<div class="text-left" style="height: 100%; max-height: 360px; width: calc(100% - 60px);">
								<img :src="activeImage ? activeImage.path : 'https://spp.agriindex.vn/storage/app/media/assets/images/noimg2.jpg'" style="width: 100%; max-height: 360px; object-fit: cover; overflow: hidden;" />
							</div>
							<div>
								<div :key="idx" v-for="(photo, idx) in activeVanDon.photos2" style="margin-left: 20px; margin-bottom: 10px;" @click="changeImageIndex(idx)">
									<div class="w-full text-left" style="cursor: pointer;">
										<img :src="photo.path" style="border-radius: 5px; box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25); width: 40px; height: 40px;" :style="{border: activeImageIndex == idx ? '2px solid #057FBB' : 'none'}" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</vs-col>
		</div>
		
	</el-dialog>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import SelectAssigned from "@/components/select-assigned/SelectAssigned";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";

let shippingOptions = {};

export default {
	name: "KcsPopup",
	components: { vSelect, SelectAssigned, CbsUploadRef },
	props: {
		isPopupActive: {
			type: Boolean,
			required: true,
		},
		activeVanDon: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			activeImage: null,
			isFormDirty: false
		};
	},
	watch: {
		isPopupActive(val) {
			if (!val) return;
			this.changeImageIndex(0);
		},

		computedFormData: {
			handler: function (newVal) {
				
			},
			deep: true,
		},
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			},
		},
	},
	created() {
	},
	methods: {

		checkReview(review, num) {
			if (review) {
				return parseInt(review) >= num;
			}
			return false;
		},
		changeImageIndex(index) {
			this.activeImage = null;
			if (this.activeVanDon) {
				this.activeImageIndex = index;
				if (this.activeVanDon.photos2 && this.activeVanDon.photos2.length) {
					this.activeImage = this.activeVanDon.photos2[index];
				}
			}
		},
	},
};
</script>

<style>
 .fieldset-custom {
	padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.2);
 }
 .vs-checkbox--check {
	/*
	-webkit-transform: translate(0%) !important;
	transform: translate(0%) !important;
	*/
	display: none;
 }
 .vs-checkbox--input:checked+.vs-checkbox .vs-checkbox--check {
	display: block;
 }
</style>